import { Card, Col, Result, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AotvLogo } from '../components/AotvLogo';
import { PageHead } from '../components/PageHead';
import { api } from '../lib/api';
import { useAuth, type Session } from '../lib/auth';

type VerifyResponse = { token: string; email: string; role: 'team' | 'speaker' };

export function VerifyMagicLinkScene() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('Missing token');
      return;
    }
    void (async () => {
      try {
        const res = await api<VerifyResponse>('/api/auth/verify', {
          method: 'POST',
          body: JSON.stringify({ token }),
        });
        const session: Session = { token: res.token, email: res.email, role: res.role };
        setSession(session);
        navigate(res.role === 'team' ? '/events' : '/me', { replace: true });
      } catch (err) {
        setError((err as { error?: string }).error ?? 'Failed to verify link');
      }
    })();
  }, [params, setSession, navigate]);

  return (
    <div className="auth-container">
      <PageHead title="Signing in" />
      <Row justify="center">
        <Col xs={22} sm={20} md={14} lg={10} xl={8}>
          <div className="auth-logo">
            <AotvLogo />
          </div>
          <Card>
            {error ? (
              <Result status="error" title="Sign-in link invalid" subTitle={error} />
            ) : (
              <div style={{ textAlign: 'center', padding: 24 }}>
                <Spin /> <span style={{ marginLeft: 12 }}>Signing you in…</span>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
}
